import styled from 'styled-components';
import { APP_CLASSNAME_PREFIX } from '../../../../constants';

export const Text = ({ data, isMobile }) => {
  const { contentTextText, contentTextColor, contentTextFontSize } = data;

  return (
    <StyledText
      dangerouslySetInnerHTML={{ __html: contentTextText }}
      onClick={(e) => e.stopPropagation()}
      $color={contentTextColor}
      $fontSize={isMobile ? 16 : contentTextFontSize}
    />
  );
};

const StyledText = styled.div.attrs({
  className: `${APP_CLASSNAME_PREFIX}-text-component`
})`
  display: block;
  margin: 20px 0;
  line-height: 1.1;
  cursor: default;
  color: ${({ $color }) => $color};
  font-size: ${({ $fontSize }) => $fontSize}px;
`;
